import { RouteSwitch } from "./app/routes";
import { isGoHost, isMainHost, normalizePath, stripGoPrefix } from "./app/routing";
import { BrandLockup } from "./components/common/BrandLockup";
import { NavLink } from "./components/common/NavLink";
import { goDomainHeaderExcludedPaths } from "./constants/routes";

export function App() {
  const currentPath = normalizePath(window.location.pathname);
  const host = window.location.hostname.toLowerCase();
  const isGoDomain = isGoHost(host);
  const isMainDomain = isMainHost(host);
  const showGoHeader = isGoDomain && !goDomainHeaderExcludedPaths.has(currentPath);

  return (
    <main className={isMainDomain ? "institutionalMain" : ""}>
      {showGoHeader && <Header currentPath={stripGoPrefix(currentPath)} />}
      <RouteSwitch currentPath={currentPath} isGoDomain={isGoDomain} isMainDomain={isMainDomain} />
    </main>
  );
}

function Header({ currentPath }: { currentPath: string }) {
  return (
    <header className="topbar" aria-label="Navegacao principal">
      <BrandLockup className="brand" href="/" />
      <nav>
        <NavLink currentPath={currentPath} href="/" label="Beauty" />
        <NavLink currentPath={currentPath} href="/pricing" label="Planos" />
        <NavLink currentPath={currentPath} href="/login" label="Login" />
      </nav>
    </header>
  );
}
